import { SetServiceDependencies } from '../../infra/startup/types';
import bindAllMethods from '../../utils/bindAllMethods';
import { ITenantHandlerService } from '../tenantHandler';
import { IPortalOnboardingService } from './IPortalOnboardingService';
import { INavigationService } from '../navigationService';
import { InternalService } from '../../core/services';

export default class PortalOnboardingService
  extends InternalService
  implements IPortalOnboardingService
{
  private _tenantHandlerService: ITenantHandlerService;
  private _navigationService: INavigationService;

  constructor() {
    super();
    bindAllMethods(this);
  }

  setDependencies(options: SetServiceDependencies): void {
    const { tenantHandlerService, navigationService } = options?.services || {};
    this._tenantHandlerService = tenantHandlerService;
    this._navigationService = navigationService;
    this._markAsReady();
  }

  public isUserOnPortalOnboardingPath(): boolean {
    const currentPortalOnboardingList =
      this._tenantHandlerService?.getPortalOnboardingList();

    return currentPortalOnboardingList?.some((portalOnboarding) => {
      return (
        portalOnboarding.route === this._navigationService.location.pathname
      );
    });
  }
}
